export function generateRandomInteger(min: number, max: number) {
  return Math.floor(min + Math.random() * (max - min + 1))
}

export function nl2br(str: string, replaceMode: boolean = false, isXhtml: boolean = true): string {
  let breakTag = (isXhtml) ? '<br />' : '<br>';
  let replaceStr = (replaceMode) ? '$1' + breakTag : '$1' + breakTag + '$2';
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
}


export function br2nl(str: string, replaceMode: boolean = false): string {
  const replaceStr = (replaceMode) ? "\n" : '';
  // Includes <br>, <BR>, <br />, </br>
  return str.replace(/<\s*\/?br\s*[\/]?>/gi, replaceStr);
}
